import { call, put, takeLatest } from 'redux-saga/effects'
import { select } from '@redux-saga/core/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { EKGImportConstants } from '../store/ekgImport.constants'
import { saveReportAttachments } from '../store/ekgImport.actions'
import { getEKGImportSelector } from '../selectors'

export function* getReportAttachments() {
  const { reportAttachments } = yield select(getEKGImportSelector)
  if (reportAttachments.length) return

  const pcrId: string = yield select(getPcrIdSelector)
  if (!pcrId) return

  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)

    if (pcrDoc._ekgReportAttachments) yield put(saveReportAttachments(pcrDoc._ekgReportAttachments))
  } catch (e) {
    yield put(throwPcrException(`getReportAttachments() error: ${e}`))
  }
}

export function* getReportAttachmentsSaga() {
  yield takeLatest([EKGImportConstants.GET_REPORT_ATTACHMENTS], getReportAttachments)
}
